import { AppPageLayout } from "@/components/common/AppPageLayout";
import ErrorPage from "@/components/pages/ErrorPage";
import { useAnalyticsCopy } from "@/features/i18n/analyticsCopy";
import { hooks as h } from "@/hooks";
import { createFileRoute, Outlet } from "@tanstack/react-router";

const AnalyticsLayout = () => {
    const copy = useAnalyticsCopy();
    h.useNav([{ label: copy.navTitle, route: { to: "/analytics" } }]);

    return (
        <AppPageLayout width="full" padding="sm" as="div">
            <Outlet />
        </AppPageLayout>
    );
};

function AnalyticsError({ error, reset }: { error: Error; reset: () => void }) {
    const copy = useAnalyticsCopy();
    return (
        <AppPageLayout width="full" padding="sm" as="div">
            <ErrorPage title={copy.failedToLoadAnalytics} error={error} reset={reset} />
        </AppPageLayout>
    );
}

export const Route = createFileRoute("/_app/analytics")({
    component: AnalyticsLayout,
    /** Keep the app shell (nav) when a child analytics route throws. */
    errorComponent: AnalyticsError,
});
